// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import FieldValidationMessages from '../validation/FieldValidationMessages';
import './FormRow.scss';
var FormRow = function FormRow(_ref) {
  var label = _ref.label,
    name = _ref.name,
    error = _ref.error,
    errors = _ref.errors,
    HelperElement = _ref.HelperElement,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "FormRow"
  }, /*#__PURE__*/React.createElement("div", {
    className: "field-info"
  }, /*#__PURE__*/React.createElement("label", {
    className: "field-label",
    htmlFor: name
  }, label), error && /*#__PURE__*/React.createElement(FieldValidationMessages, {
    sanitisedError: error
  }), errors && errors.map(function (err, index) {
    return /*#__PURE__*/React.createElement(FieldValidationMessages, {
      sanitisedError: err,
      key: index
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "field-row"
  }, Array.isArray(children) ? children.map(function (child, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "field",
      key: index
    }, child);
  }) : /*#__PURE__*/React.createElement("div", {
    className: "field"
  }, children)), HelperElement && /*#__PURE__*/React.createElement("div", {
    className: "field-helper"
  }, HelperElement));
};
FormRow.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.object,
  errors: PropTypes.arrayOf(PropTypes.object),
  HelperElement: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};
export default FormRow;